import { createSlice } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import { AuthType } from "types"

export const initialState: AuthType = {
  id: null,
  accessToken: null,
  refreshToken: null,
  redirect: null,
}

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateRedirect: (state, { payload }) => {
      const { redirect } = payload

      state.redirect = redirect
    },
    login: (state, { payload }) => {
      const { id, accessToken, refreshToken } = payload

      state.id = id
      state.accessToken = accessToken
      state.refreshToken = refreshToken
    },
    logout: () => {
      return initialState
    },
  },
})

export const { updateRedirect, login, logout } = authSlice.actions

export const selectId = (state: RootState) => state.auth.id
export const selectAccessToken = (state: RootState) => state.auth.accessToken
export const selectRedirect = (state: RootState) => state.auth.redirect

export default authSlice.reducer
